// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"nE-z","smallCardRow":"oE-z","largeCardRow":"pE-z","productSearchRow":"qE-z","curatedRow":"rE-z"};